import styled from "styled-components";

export const LastLoginContainerBox = styled.div`
    @media ${({ theme }) => theme.mediaQuery.mAndBelow} {
        padding-inline-end: 10px;
        border-inline-end: 1px solid ${props => props.theme.colors.textMiddleDark};
    }

    @media ${({ theme }) => theme.mediaQuery.lAndAbove} {
        padding-block-end: 10px;
        border-block-end: 1px solid ${props => props.theme.colors.textMiddleDark};
    }
`;

export const LastLoginContainerDefaultBox = LastLoginContainerBox;